import React from "react"
import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"
import { createStyles } from "@mantine/core"

const useStyles = createStyles((theme, { charTruncate }: { charTruncate?: number }) => ({
    annotation: {
        color: theme.colors.brand[4],
        textOverflow: "ellipsis",
        overflow: "hidden",
    },
    label: {
        textOverflow: "ellipsis",
        // allows the text to be the first thing to truncate instead
        // of the number
        "max-width": `calc(100% - ${charTruncate ?? 0}ch)`,
        overflow: "hidden",
    },
    countCell: {
        textAlign: "right",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: ".25rem .5rem",
        "white-space": "nowrap",
        overflow: "hidden",
    },
}))

export const MantineAggregationCell = ({ label, value }) => {
    //
    const { classes } = useStyles({ charTruncate: value?.length })
    if (typeof value === "undefined") {
        return null
    }
    // set tooltip title on content
    const title = `${label} ${value}`

    return (
        <CellWrapper truncate lineClamp={1} isNumeric>
            <div className={classes.countCell} title={title}>
                <span className={classes.label}>{label + "\u00A0"}</span>
                <span className={classes.annotation}>{value}</span>
            </div>
        </CellWrapper>
    )
}
